import { Action } from '../Action.js';
/**
 * @description This action tracks the users who have logged-in to the system or who have identify called for them
 * @trigger This action is triggered when a user is identified
 */
export default class UserSessionStarted extends Action {
    constructor() {
        super(...arguments);
        this.id = 'user.sessionStarted';
    }
}
//# sourceMappingURL=UserSessionStarted.js.map